export const PopulationType_General = 'general';
export const PopulationType_Specific = 'specific';
export const PopulationTypes = [PopulationType_General, PopulationType_Specific];
//# sourceMappingURL=types.js.map